"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.greys = exports.TextColorKeys = void 0;
let TextColorKeys;
exports.TextColorKeys = TextColorKeys;

(function (TextColorKeys) {
  TextColorKeys["white"] = "white";
  TextColorKeys["grey10"] = "grey10";
  TextColorKeys["grey20"] = "grey20";
  TextColorKeys["grey30"] = "grey30";
  TextColorKeys["grey40"] = "grey40";
  TextColorKeys["grey50"] = "grey50";
  TextColorKeys["grey60"] = "grey60";
  TextColorKeys["grey70"] = "grey70";
  TextColorKeys["grey90"] = "grey90";
  TextColorKeys["black"] = "black";
  TextColorKeys["gold"] = "gold";
  TextColorKeys["transparent"] = "transparent";
  TextColorKeys["primary"] = "primary";
  TextColorKeys["negative"] = "negative";
  TextColorKeys["positive"] = "positive";
  TextColorKeys["warning"] = "warning";
})(TextColorKeys || (exports.TextColorKeys = TextColorKeys = {}));

const greys = {
  white: '#FFFFFF',
  grey10: '#F2F4F5',
  grey20: '#E9EAEC',
  grey30: '#D6DADE',
  grey40: '#C2C8CE',
  grey50: '#A4ADB6',
  grey60: '#848C98',
  grey70: '#6A747F',
  // grey80 is intentionally left empty
  grey90: '#36424E',
  black: '#000000'
};
exports.greys = greys;